module.exports = __webpack_public_path__ + "img/viscous_ooze_sticky_membrane.e8ebeb16.png";